<template>
    <button class="btn btn-primary">
        <slot />
    </button>
</template>
